/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Pagination } from "../../commons/types/Pagination";
import { Canvas } from "./Canvas";
export const ListCanvasesResponse = core.serialization.object({
    pagination: Pagination.optional(),
    data: core.serialization.list(Canvas),
});
